import reducer from "./reducers";
import { routes } from "../routes";
import * as authOperations from "./operations";
import selectors from "./selectors";

export {
    authOperations,
    selectors
};

export default {
    routes,
    reducer
}
